<!--
 * @Description:
 * @version:
 * @Author: huhuan
 * @Date: 2022-09-22 15:19:12
 * @LastEditors: 胡奂 huhuan@moredian.com
 * @LastEditTime: 2023-06-25 10:47:45
-->
<template>
  <div class="pageQuestion m-hp-100 m-hidden m-fb-col m-fb-cross-center">
    <div class="m-w-1152">
      <CommonHeader title="常见问题">
        <div class="m-fb m-fb-cross-center">
          <span>问题未得到解决，或想提供意见建议？</span> <span class="but" @click="handlerToFeedback">我要反馈</span>
        </div>
      </CommonHeader>
    </div>
    <CommonBox class="m-item-flex-1 m-auto m-hidden m-bg-FFFFFF m-p-0-48 m-pt-32 m-pb-48 m-fb-col">
      <div v-if="questList.length" class="m-item-flex-1">
        <div class="item m-p-16-0" v-for="(item, index) in questList" :key="index">
          <div class="m-font-16 m-newline m-bold">{{ item.question }}</div>
          <div class="m-font-16 m-newline m-mt-8 m-c-191A26">{{ item.answer }}</div>
        </div>
      </div>
      <div class="m-item-flex-1 m-fb-col-center-center" v-else>
        <img class="nothing" src="../assets/imgs/noData/暂无数据.png" alt="" />
        <div class="m-c-999999 ">暂无记录</div>
      </div>
    </CommonBox>
  </div>
</template>

<script>
export default {
  created() {
    this.init()
  },
  data() {
    return {
      questList: [] //问题列表
    }
  },
  methods: {
    async init() {
      this.questList = await this.fetchCommonQuestionList()
    },
    /**
     * @Description: 跳转到我要反馈
     * @return {*}
     */
    handlerToFeedback() {
      this.$router.push({
        path: '/feedback'
      })
    },
    /**
     * @Description: 常见问题
     * @return {*}
     */
    fetchCommonQuestionList() {
      return this.$httpPost('commonQuestionList')
    }
  }
}
</script>
<style scoped lang="scss">
.pageQuestion {
  .nothing {
    width: 200px;
    height: 200px;
  }
  .but {
    width: 88px;
    line-height: 36px;
    border: 1px solid #ffffff;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
  }
  .item {
    border-bottom: 1px solid #e8e8e8;
    &:last-child {
      border: 0px;
    }
  }
}
</style>
